<template>
  <div>
    <button class="transition btn-report sparkYellow my-5 uppercase text-bold mx-2" @click="editClicked">{{
        $t('edit')
      }}
    </button>
    <button class="btn-report pureNavy transition push"
            :class="{'cursor-wait opacity-30' : !!isLoading, 'cursor-not-allowed opacity-30': !isReportSelected || !isReportEditable}"
            v-tooltip="!isReportSelected ? $t('select_report_first') : null" @click="openModalNewReport(null)">
      {{ $t('save_as_own_report') }}
    </button>
    <button class="btn-report pureNavy" @click="openModalChangeReport">{{ $t('change_report') }}</button>
    <button class="btn-report steelBlue" @click="openModalNewShared(null)">{{ $t('create_shared_short') }}</button>
    <button class="btn-report steelBlue" @click="openModalNewSchedule(null)">{{ $t('create_schedule_short') }}</button>
    <button class="btn-report steelBlue" @click="csvExport">{{ $t('export') }}</button>
    <button :disabled="!!isLoading" :class="{'cursor-wait opacity-30' : !!isLoading}"
            class="transition btn-report sparkYellow my-5 uppercase text-bold mx-2" @click="goto('report-result')">
      {{ $t('run') }}
    </button>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import ModalService from '../modules/modals/services/modal.service'
import ModalEditReport from "@/components/ModalEditReport.vue";
import ModalNewSchedule from "@/components/ModalNewSchedule.vue";
import ModalNewShared from "@/components/ModalNewShared.vue";
import ModalNewReport from "@/components/ModalNewReport.vue";
import ModalChangeReport from "@/components/ModalChangeReport.vue";
import ModalSomethingWentWrong from "@/components/ModalSomethingWentWrong.vue";

export default {
  name: 'reportButtons',
  data() {
    return {
      isReportEditable: false,
    }
  },
  computed: {
    ...mapGetters([
      'isLoading', 'newReport', 'activeReport', 'findReport', 'chartName'
    ]),
    isReportSelected() {
      this.checkEditable()
      return !!this.activeReport.report;
    },
  },
  methods: {
    ...mapActions({
      exportToCsv: 'exportToCsv',
      generateReport: 'generateReport',
    }),
    ...mapMutations({
      setLastRunChartType: 'setLastRunChartType',
      setLastRunStackBy: 'setLastRunStackBy',
      setLastRunGroupBy: 'setLastRunGroupBy',
    }),
    editClicked() {
      ModalService.open(ModalEditReport)
    },
    checkEditable() {
      if (this.activeReport.report !== null) {
        const report = this.findReport((this.activeReport.report))
        if ((report.editPermission === null || report.editPermission === true)) {
          this.isReportEditable = true
          return
        }
      }
      this.isReportEditable = false
    },
    csvExport() {
      const payload = {
        backward_interval: this.newReport.backward_interval,
        columns: this.newReport.view_columns_stringify,
        filters: this.newReport.filters_stringify,
        group_by: this.newReport.group_by_stringify,
        order_by: this.newReport.order_by_stringify,
        aggregate: this.newReport.aggregate ? this.newReport.aggregate_stringify : null,
        additionalGroupBy: this.newReport.additionalGroupBy ? this.newReport.additionalGroupBy_stringify : null,
        date_from: this.newReport.date_from,
        date_to: this.newReport.date_to,
        cover_type: this.newReport.cover_type,
        chart_id: this.newReport.chart_id,
        service: this.newReport.service_name,
      }
      this.exportToCsv({payload, endpoint: 'report'})
    },
    openModalNewReport(id) {
      if (this.isReportSelected && this.isReportEditable) ModalService.open(ModalNewReport, {id: id});
    },
    openModalNewSchedule(id) {
      ModalService.open(ModalNewSchedule, {id: id});
    },
    openModalNewShared(id) {
      ModalService.open(ModalNewShared, {id: id});
    },
    openModalChangeReport() {
      ModalService.open(ModalChangeReport, {id: null});
    },
    goto(el) {
      this.isLoading = true
      const payload = {
        backward_interval: this.newReport.backward_interval,
        columns: this.newReport.view_columns_stringify,
        filters: this.newReport.filters_stringify,
        group_by: this.newReport.group_by_stringify,
        stack_by: this.newReport.stack_by_stringify,
        order_by: this.newReport.order_by_stringify,
        date_from: this.newReport.date_from,
        date_to: this.newReport.date_to,
        cover_type: this.newReport.cover_type,
        chart_id: this.newReport.chart_id,
        map: this.newReport.map ? this.newReport.map : false,
        service: this.newReport.service_name,
        aggregate: this.newReport.aggregate ? this.newReport.aggregate_stringify : null,
        additionalGroupBy: this.newReport.additionalGroupBy ? this.newReport.additionalGroupBy_stringify : null
      }
      this.generateReport(payload).then(() => {
        document.getElementById(el).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'})
        this.setLastRunChartType(this.chartName)
        this.setLastRunStackBy(this.newReport.stack_by)
        this.setLastRunGroupBy(this.newReport.group_by)
      }).catch(() => {
        ModalService.open(ModalSomethingWentWrong)
      }).finally(() => {
        this.isLoading = false
      })
    },
  }
}
</script>